import { defineMessages } from "react-intl";

const RESET_PASSWORD_FORM = "reset-password-form";

const resetPasswordFormMessages = defineMessages({
  unableToResetPassword: {
    id: `${RESET_PASSWORD_FORM}.unable-to-reset-password`,
    defaultMessage: "Unable to reset your password. Please try again later."
  },
  tooMuchTime: {
    id: `${RESET_PASSWORD_FORM}.too-much-time`,
    defaultMessage:
      "Sorry, too much time has passed. You must start the process again. <button>Start over</button>"
  }
});

export default resetPasswordFormMessages;
